import React from 'react'

const VoteIcon = ({ color = '#ffffff', iconClass = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.813"
      height="14.982"
      className={`${iconClass}`}
      viewBox="0 0 14.813 14.982"
    >
      <path
        data-name="like-svgrepo-com (1)"
        d="M7.214 8.672H4v8.035h3.214m0-8.035v8.035m0-8.035L11.389 3.8A1.607 1.607 0 0 1 13 3.288l.038.01a1.607 1.607 0 0 1 .947 2.451l-1.949 2.923H15.7a1.607 1.607 0 0 1 1.576 1.922l-.964 4.821a1.607 1.607 0 0 1-1.576 1.292H7.214"
        transform="translate(-3.25 -2.475)"
        style={{
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.5px',
        }}
      />
    </svg>
  )
}

export default VoteIcon
